/**
* Videos
*/

$(() => {
    $('.video__play-button').on('click', function() {
      var video = $(this).closest('.video').find('video')[0];
      if (video) {
        video.play();
        $(this).fadeOut();
      }
    });
  });